import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";
import PageMessage from "2g-page-message";

import useMessages from "./i18n/useMessages";
import FixniPozadavkyBoxObdobiItem from "./FixniPozadavkyBoxObdobiItem";

export function FixniPozadavkyBoxObdobi({
  loading,
  error,
  fazeObdobiFixni,
  fazeObdobiVsechny,
  faze
}) {
  const messages = useMessages();
  return (
    <div className="b2b-FixniPozadavkyBoxObdobi">
      {loading ? (
        <PlaceholderText>
          <label>Období požadavků</label>
          <div>Fixní požadavky je možné zadávat od po 12 do ne 08</div>
          <div>Požadavky je možné zadávat od po 12 do ne 08</div>
        </PlaceholderText>
      ) : error ? (
        <PageMessage inline>{error}</PageMessage>
      ) : (
        <>
          <div className="b2b-FixniPozadavkyBoxObdobi-label">
            {messages.textObdobi()}
          </div>
          <FixniPozadavkyBoxObdobiItem
            label={messages.textFixni()}
            obdobi={fazeObdobiFixni}
          />
          <FixniPozadavkyBoxObdobiItem
            label={messages.textVsechny()}
            obdobi={fazeObdobiVsechny}
          />
        </>
      )}
    </div>
  );
}

FixniPozadavkyBoxObdobi.propTypes = {
  loading: T.bool,
  error: T.oneOfType([T.bool, T.string]),
  fazeObdobiFixni: T.object,
  fazeObdobiVsechny: T.object,
  faze: T.shape({ fixni: T.bool, vsechny: T.bool })
};

export default React.memo(FixniPozadavkyBoxObdobi);
